// extracted by mini-css-extract-plugin
module.exports = {"root":"StudentRow_root__2qnqS","description":"StudentRow_description__3tRvS","count":"StudentRow_count__XfrUP"};